// InteliChat adapter: the logged-in agent (identity block, greeting,
// availability). Reads native auth getters only - no direct state access.
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const AVAILABILITY_LABEL = {
  online: 'Available',
  busy: 'Busy',
  offline: 'Offline',
};

const AVAILABILITY_TONE = {
  online: 'good',
  busy: 'warn',
  offline: 'plain',
};

export function useInteliAgent() {
  const currentUser = useMapGetter('getCurrentUser');
  const availability = useMapGetter('getCurrentUserAvailability');
  const currentRole = useMapGetter('getCurrentRole');

  const displayName = computed(
    () =>
      currentUser.value?.available_name ||
      currentUser.value?.name ||
      currentUser.value?.email ||
      ''
  );

  const firstName = computed(() => displayName.value.split(' ')[0] || '');

  const initials = computed(() =>
    displayName.value
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map(part => part[0].toUpperCase())
      .join('')
  );

  const availabilityLabel = computed(
    () => AVAILABILITY_LABEL[availability.value] || 'Offline'
  );

  const availabilityTone = computed(
    () => AVAILABILITY_TONE[availability.value] || 'plain'
  );

  const isAdmin = computed(() => currentRole.value === 'administrator');

  return {
    currentUser,
    displayName,
    firstName,
    initials,
    availability,
    availabilityLabel,
    availabilityTone,
    isAdmin,
  };
}
